import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Paragraph,
} from '@/components/atoms';
import type { OmnichannelAccount } from '@/types';

interface PageSelectorProps {
  accounts: OmnichannelAccount[];
  selectedPageId: string | undefined;
  onPageSelect: (pageId: string) => void;
  isLoading?: boolean;
}

export const PageSelector = ({
  accounts,
  selectedPageId,
  onPageSelect,
  isLoading,
}: PageSelectorProps) => {
  if (!accounts || accounts.length === 0) return null;

  return (
    <div className="mb-4">
      <Paragraph className="text-gray-500 mb-2">
        Choose your business page
      </Paragraph>
      <Select
        value={selectedPageId || ''}
        onValueChange={onPageSelect}
        disabled={isLoading}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Select a page" />
        </SelectTrigger>
        <SelectContent>
          {accounts.map((account) => (
            <SelectItem key={account.pageId} value={account.pageId}>
              <div className="flex items-center gap-2">
                {account.profilePictureUrl && (
                  <img
                    src={account.profilePictureUrl}
                    alt={account.name}
                    className="w-6 h-6 rounded-full"
                  />
                )}
                <span>{account.name}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
